<template>
	<div :class="{ 'dropdown-container': true, open: isDropdownOpen }">
		<form @submit="onSubmitHandler">
			<InputTextbox
				:label="label"
				v-model:saturn="text"
				:placeholder="placeholder"
				@focus="onClickHandler"
				@blur="onBlurHandler"
				@change="onChangeHandler"
				:autocomplete="autocomplete"
				:invalid="invalid"
				icon="far fa-list-alt"
				:showIcon="showIcon"
				ref="autocompleteInput"
				:disabled="disabled"
				:autofocus="autofocus ? autofocus : false"
			>
				<template #validation>
					<div
						v-for="(valid, index) in validations"
						:key="index"
					>
						<div v-if="valid.validation">{{ valid.text }}</div>
					</div>
				</template>
			</InputTextbox>
		</form>
		<div
			:style="{ width: optionsWidth + 'px' }"
			:class="{
				dropdown: true,
				open: isDropdownOpen,
				up: dropUp,
				right: listAlignRight,
			}"
			v-if="isDropdownOpen"
		>
			<div
				class="list-container"
				v-if="handleObject"
			>
				<ul v-if="tooltipDisplayDirection">
					<li
						v-for="(item, index) in filteredList"
						:key="index"
						@click="onSelectItemHandler(item)"
					>
						<TooltipComponent
							:text="item[searchKeys[0]]"
							:action="{ function: onSelectItemHandler, param: item }"
							:tooltip="tooltipTextCreation(item)"
							:direction="tooltipDisplayDirection"
							class="list-item"
							:tooltipOffset="tooltipOffset"
						>
						</TooltipComponent>
					</li>
				</ul>
				<ul v-else>
					<li
						v-for="(item, index) in filteredList"
						:key="index"
						@click="onSelectItemHandler(item)"
						class="list-item"
					>
						{{ displayItem(item) }}
					</li>
				</ul>
			</div>
			<div v-else>
				<ul v-if="tooltipDisplayDirection">
					<li
						v-for="(item, index) in filteredList"
						:key="index"
						@click="onSelectItemHandler(item)"
					>
						<TooltipComponent
							:text="item"
							:action="{ function: onSelectItemHandler, param: item }"
							:tooltip="tooltipTextCreation(item)"
							:direction="tooltipDisplayDirection"
							class="list-item"
							:tooltipOffset="tooltipOffset"
						>
						</TooltipComponent>
					</li>
				</ul>
				<ul v-else>
					<li
						v-for="(item, index) in filteredList"
						:key="index"
						@click="onSelectItemHandler(item)"
						class="list-item"
					>
						{{ item }}
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import InputTextbox from '@/components/customerApp/InputTextbox.vue';
	import TooltipComponent from '@core/components/TooltipComponent.vue';

	export default {
		name: 'AutocompleteComponent',
		emits: ['blur', 'change', 'selected', 'focus', 'submit'],
		props: [
			'autocomplete', // Boolean
			'data',
			'mainKey',
			'display',
			'searchKeys',
			'displayKeys',
			'tooltipDisplayDirection',
			'preSelected',
			'placeholder',
			'label',
			'invalid',
			'validations',
			'tooltipOffset',
			'showIcon',
			'dropUp',
			'listAlignRight',
			'clearOnSelect',
			'disabled',
			'autofocus',
		],
		data() {
			return {
				text: null,
				isDropdownOpen: false,
				filteredList: [],
				floatingInfo: {},
				itemSelected: false,
			};
		},
		computed: {
			handleObject() {
				return typeof this.data[0] == 'object';
			},
			optionsWidth() {
				const optionsBordersWidth = 2;
				return this.$refs.autocompleteInput.$refs.container.offsetWidth - optionsBordersWidth;
			},
		},
		created() {
			this.filteredList = [...this.data];
			this.$watch(
				() => this.data,
				() => {
					this.filteredList = [...this.data];
				},
			);
			this.text = this.preSelected ? this.displayItem(this.preSelected) : '';
			this.$watch(
				() => this.preSelected,
				() => {
					this.text = this.preSelected ? this.displayItem(this.preSelected) : '';
				},
			);
		},
		methods: {
			displayItem(item) {
				return this.display ? this.display.map(dk => item[dk]).join(' ') : item[this.searchKeys[0]];
			},
			tooltipTextCreation(item) {
				return this.displayKeys.map(dk => dk.label + ' ' + item[dk.key]);
			},
			onClickHandler($e) {
				this.itemSelected = false;
				this.isDropdownOpen = true;
				this.$emit('focus', $e);
			},
			onBlurHandler($e) {
				setTimeout(() => {
					if (!this.itemSelected) {
						if (this.handleObject) {
							const object = this.preSelected ? this.data.find(d => d[this.mainKey] == this.preSelected[this.mainKey]) : null;
							if (object) {
								this.text = object[this.searchKeys[0]] ?? '';
							} else {
								this.text = '';
							}
						} else {
							this.text = this.preSelected ? this.preSelected : '';
						}
					}
					this.isDropdownOpen = false;
					this.$emit('blur', $e);
				}, 200);
			},
			onSubmitHandler(e) {
				e.preventDefault();
				this.$emit('submit', e);
			},
			onChangeHandler() {
				//filter list of options
				this.filteredList = [];
				this.data.forEach(d => {
					if (this.handleObject) {
						if (this.searchKeys.some(searchKey => d[searchKey] && d[searchKey].toLowerCase().includes(this.text ? this.text.toLowerCase() : ''))) {
							this.filteredList.push(d);
						}
					} else {
						if (d.toLowerCase().includes(this.text.toLowerCase())) {
							this.filteredList.push(d);
						}
					}
				});
				this.$emit('change', this.text, this.filteredList);
			},
			updateToNotListedText(notListedText) {
				this.text = notListedText;
				return this.text;
			},
			onSelectItemHandler(item) {
				const searchText = this.text;
				if (this.handleObject) {
					if (this.clearOnSelect) {
						this.text = '';
					} else {
						//console.log(item, this.searchKeys, item[this.searchKeys[0]])
						this.text = this.displayItem(item);
					}
				} else {
					this.text = item;
				}
				this.isFloatingOpen = false;
				this.itemSelected = true;
				this.$emit('selected', item, () => this.updateToNotListedText(searchText));
			},
		},
		components: {
			InputTextbox,
			TooltipComponent,
		},
	};
</script>
<style></style>
